import { Skeleton } from "@/components/ui/skeleton";

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
}

export default function LoadingSpinner({ 
  size = 'md', 
  message = 'Loading...' 
}: LoadingSpinnerProps) {
  const sizeMap = {
    sm: 'h-8 w-8',
    md: 'h-12 w-12',
    lg: 'h-16 w-16',
  };
  
  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <div className={`animate-spin rounded-full border-4 border-muted border-t-primary ${sizeMap[size]}`}></div>
      {message && <p className="text-sm text-muted-foreground">{message}</p>}
    </div>
  );
}